<template>
  <span :title="type" :class="['micad_locationLevelIcon',getClass(type)]"></span>
</template>

<script>
export default {
  name: 'location-level-icons',
  props: {
    type: String,
  },
  methods: {
   getClass(type) {
    if (type !== undefined) {
        return ' micad_locationLevelIcon_'+type
      }
    }
  }
};
</script>